import { render, staticRenderFns } from "./select-the-class.vue?vue&type=template&id=5448b02a&scoped=true"
import script from "./select-the-class.vue?vue&type=script&lang=ts"
export * from "./select-the-class.vue?vue&type=script&lang=ts"
import style0 from "./select-the-class.vue?vue&type=style&index=0&id=5448b02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448b02a",
  null
  
)

export default component.exports